import React from "react"
// import { scaleDown as BurgerMenu } from 'react-burger-menu'
// import styled from 'styled-components'
// import { Link } from 'gatsby'
// import MenuLogo from '../fonts/logo.svg'
//import AniLink from "gatsby-plugin-transition-link/AniLink"
import { Helmet } from "react-helmet"
import { useState, useLayoutEffect } from "react"

// const LineHorizontal = styled.div`
//   box-sizing: border-box;
//   background: #2C333F;
//   height: 1px;
//   width: 95%;
//   margin: auto;
// `
function doInitFBAPP() {
  window.FB.Event.subscribe("xfbml.ready", function (msg) {
    console.log("xfbml.ready", msg.type)
    if (msg.type === "video") {
      //     var my_video_player;
      //     debug_backtrace
      if (!window.si_widget_vars) {
        window.si_widget_vars = {}
      }

      if (!window.si_widget_vars.fb_live_player) {
        window.si_widget_vars.fb_live_player = {}
      }
      let _msg_id = msg.id
      window.si_widget_vars.fb_live_player[_msg_id] = msg
    }
  })
  window.fbAsyncInit = function () {
    window.FB.init({
      appId: "640056429925448",
      xfbml: true,
      autoLogAppEvents: true,
      cookie: true,
      version: "v10.0",
    })

    // Get Embedded Video Player API Instance
    window.FB.Event.subscribe("xfbml.ready", function (msg) {
      console.log("xfbml.ready", msg.type)
      if (msg.type === "video") {
        //     var my_video_player;
        //     debug_backtrace
        if (!window.si_widget_vars) {
          window.si_widget_vars = {}
        }

        if (!window.si_widget_vars.fb_live_player) {
          window.si_widget_vars.fb_live_player = {}
        }
        let _msg_id = msg.id
        window.si_widget_vars.fb_live_player[_msg_id] = msg
      }
    })
  }
}



function doInitFbLive() {
  if (document && !document.getElementById("fb-root")) {

    const script = document.createElement("div")
    script.id = "fb-root"
    document.body.prepend(script)
  } else {
    setTimeout(() => {
      doInitFbLive();
    }, 200);
  }
  if (document && document.getElementById("fb-root")) {
    if (window.FB) {
      doInitFBAPP();
    } else {
      setTimeout(() => {
        doInitFbLive();
      }, 200);
    }
  }
}

function buildFbLive() {
  var ar = {
    box_view: "by_scroll",
    video_id: "",
    placeholder_image: "",
    placeholder_url: "",
    ignore_global_disabled: false,
    not_autoplay: false,
    panels_info: {
      class: "StartupItalia_FB_live_Widget",
      raw: false,
      grid: 3,
      cell: 0,
      id: 4,
      widget_id: "8bd9796b-4489-4f6e-8207-c55a03b6c698",
      style: { background_image_attachment: false, background_display: "tile" },
      cell_index: 0,
      widget_index: 4,
    },
  }
  // ["apple","orange",1,false,null,true,8];
  // access 4th element in array
  ar["id_container"] = "5fca2f7dc5238"
  ar["id_container_fixed"] = "si-fb-live-fix-5fca2f7dc5238"
  ar["id_container_float"] = "si-fb-live-float-5fca2f7dc5238"
  ar["already_try_to_play"] = false
  ar["box_view"] = "by_scroll"

  if (!window.si_widget_vars) {
    window.si_widget_vars = {}
  }

  if (!window.si_widget_vars.fb_live) {
    window.si_widget_vars.fb_live = []
  }
  window.si_widget_vars.fb_live.push(ar)
}

function fireXFBML() {
  const el = document.getElementById("si-fb-live-5fca2f7dc5238");
  if (window.FB && el) {
    window.FB.XFBML.parse(el.parentNode);
  }
}

const Livefb = (props) => {
  // const {
  //   //vertical: {  },
  // } = props

  const [livedata, setLivedata] = useState(null)
  const [closelive, setCloselive] = useState(false)

  function closeLive() {
    setCloselive(true)
  }

  useLayoutEffect(() => {
    //if (done == window.location.pathname) return;
    //window.alert('useLayoutEffect');

    var request_infinite =
      "https://admin.startupitalia.eu/wp-json/wpse/v1/live-data/"
    fetch(request_infinite, {
      credentials: "omit",
      headers: {
        accept: "application/json",
        "content-type": "application/json",
      },
      method: "GET",
      mode: "cors",
    })
      .then((response) => response.json()) // parse JSON from request
      .then((resultData) => {
        //setNextPost(resultData.items[0]);
        window.live = resultData
        if (resultData && resultData.data) {
          //TODO: Check the timing startdate_utime and stopdate_utime
          var now = Math.floor(Date.now() / 1000)
          //alert ("now "+(now-resultData.data.startdate_utime)+ " startdate_utime: "+resultData.data.startdate_utime)
          //alert ("now "+(now-resultData.data.stopdate_utime)+ " stopdate_utime: "+resultData.data.stopdate_utime)
          if (now >= resultData.data.startdate_utime - (3600*2) && now <= resultData.data.stopdate_utime - (3600*1)) {
            // Fixed video, da togliere
            //alert("live attiva")
            // resultData.data.video_id = "1158084488024558"

            //alert(resultData.data.startdate_utime);
            setLivedata(resultData.data);

            doInitFbLive();
            buildFbLive();
            fireXFBML();

            // const script = document.createElement("script")
            // script.type = "text/javascript"
            // script.src = "/js/fblive.js?ver=1.4.16"
            // script.id = "script-si-fb-live-js"
            // script.async = true
            // document.body.appendChild(script)

            // const _script = document.createElement("script")
            // script.type = "text/css"
            // script.rel = "stylesheet"
            // script.id = "style-si-fb-live-css"
            // script.href = "/css/fblive.css?ver=1.4.22"
            // script.media = "all"
            // script.async = true
            // document.body.appendChild(_script)
          }
        }
        //loading = false;
      }) // set data for the number of stars

    return () => {
      //window.alert('useLayoutEffectUmount ?');
      //Umount
    }
  }, [])

  return (
    <div
      style={{
        display: livedata && !closelive ? "block" : "none",
        position: "fixed",
        bottom: "0",
        right: "0",
        zIndex: "999",
        width: "240px",
        height: "133px",
        marginRight: "20px",
        marginBottom: "20px",
        backgroundColor: "white",
      }}
    >
      {/* <div id="fb-root"></div> */}
      {livedata && (
        <div
          tc_start_date={livedata.startdate_utime}
          style={{ width: "100%", height: "100%" }}
        >
          <div
            role="button"
            tabIndex="0"
            style={{
              position: "absolute",
              zIndex: "99",
              right: "0",
              cursor: "pointer",
              backgroundColor: "white",
              borderRadius: "15px",
              width: "20px",
              height: "20px",
              marginRight: "3px",
              marginTop: "3px",
            }}
            onClick={() => closeLive()}
            onKeyDown={(event) => {
              if (event.key === "Enter") closeLive()
            }}
          >
            <p
              style={{
                marginTop: "-6px",
                marginLeft: "4px",
                fontWeight: "800",
              }}
            >
              X
            </p>
          </div>
          <Helmet>
            <script
              type="text/javascript"
              src="/js/fblive.js?ver=1.4.16"
              id="script-si-fb-live-js"
            ></script>
            <link
              rel="stylesheet"
              id="style-si-fb-live-css"
              href="/css/fblive.css?ver=1.4.22"
              type="text/css"
              media="all"
            />
          </Helmet>
          {/* <div
            dangerouslySetInnerHTML={{
              __html: `
              <script type="text/javascript">
                console.log('window.FB', window.FB);
                if (window.FB) {
                        FB.Event.subscribe('xfbml.ready', function(msg) {
                        console.log('xfbml.ready', msg.type)
                        if (msg.type === 'video') {
                            if (!window.si_widget_vars) {
                                window.si_widget_vars = {};
                            }

                            if (!window.si_widget_vars.fb_live_player) {
                                window.si_widget_vars.fb_live_player = {};
                            }
                            let _msg_id = msg.id;
                            window.si_widget_vars.fb_live_player[_msg_id] = msg;
                        }
                    });

                }
                window.fbAsyncInit = function() {
                    FB.init({
                        appId      : '640056429925448',
                        xfbml      : true,
                        autoLogAppEvents : true,
                        cookie     : true,
                        version    : 'v7.0'
                    });

                    // Get Embedded Video Player API Instance
                    FB.Event.subscribe('xfbml.ready', function(msg) {
                        console.log('xfbml.ready', msg.type)
                        if (msg.type === 'video') {
                            if (!window.si_widget_vars) {
                                window.si_widget_vars = {};
                            }

                            if (!window.si_widget_vars.fb_live_player) {
                                window.si_widget_vars.fb_live_player = {};
                            }
                            let _msg_id = msg.id;
                            window.si_widget_vars.fb_live_player[_msg_id] = msg;
                        }
                    });
                };
            </script>
            `,
            }}
          /> */}
          <div
            className="si-fb-live-widget-box box_show_by_scroll"
            id="si-fb-live-5fca2f7dc5238"
            style={{ width: "100%", height: "100%" }}
          >
            <div
              className="si-fb-live-main-container"
              style={{
                width: "100%",
                maxWidth: "100%",
                margin: "auto",
                height: "100%",
              }}
            >
              <center style={{ width: "100%", height: "100%" }}>
                <a
                  href="https://www.facebook.com/StartupItalia.eu/live"
                  target="_blank"
                  className="bg-img-placeholder"
                  rel="noreferrer"
                >
                  <div
                    className="si-fb-live-video-container"
                    style={{
                      backgroundSize: "cover",
                      backgroundImage:
                        "url('" + livedata.placeholder_image + "')",
                      marginottom: "0px",
                      maxWidth: "100%",
                      height: "100%",
                      margin: "0px",
                    }}
                  >
                    <div
                      className="fb-video"
                      style={{ maxWidth: "100% !important" }}
                      data-href={
                        "https://www.facebook.com/facebook/videos/" +
                        livedata.video_id
                      }
                      // data-width="auto"
                      // data-href={
                      //   "https://www.facebook.com/275576236199956/videos/261385882445017"
                      // }
                      id="vp-5fca2f7dc5238"
                      // data-show-text="false"
                      data-autoplay="true"
                    >
                      <div className="fb-xfbml-parse-ignore">
                        <div>loading</div>
                      </div>
                    </div>
                  </div>
                </a>
              </center>
            </div>
          </div>

          {/* <div
            dangerouslySetInnerHTML={{
              __html: `
              <script type="text/javascript">
                  var ar = {"box_view":"by_scroll","video_id":"","placeholder_image":"","placeholder_url":"","ignore_global_disabled":false,"not_autoplay":false,"panels_info":{"class":"StartupItalia_FB_live_Widget","raw":false,"grid":3,"cell":0,"id":4,"widget_id":"8bd9796b-4489-4f6e-8207-c55a03b6c698","style":{"background_image_attachment":false,"background_display":"tile"},"cell_index":0,"widget_index":4}};
                  // ["apple","orange",1,false,null,true,8];
                  // access 4th element in array
                  ar['id_container'] = "5fca2f7dc5238";
                  ar['id_container_fixed'] = "si-fb-live-fix-5fca2f7dc5238";
                  ar['id_container_float'] = "si-fb-live-float-5fca2f7dc5238";
                  ar['already_try_to_play'] = false;
                  ar['box_view'] = "by_scroll";

                  if (!window.si_widget_vars) {
                      window.si_widget_vars = {};
                  }

                  if (!window.si_widget_vars.fb_live) {
                      window.si_widget_vars.fb_live = [];
                  }
                  window.si_widget_vars.fb_live.push(ar);
              </script>
            `,
            }}
          /> */}
        </div>
      )}
    </div>
  )
}

export default Livefb
